import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import "../../css/Admin-PhotoGallery/AdminEditPhotoGallery.css";
import Spinner from "../Spinner";

const AdminEditPhotoGallery = ({ onClose, productData, fetchData, projectKey }) => {
  const [uploadPhotoGallery, setUploadPhotoGallery] = useState(0);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    ...productData,
    photoGalleryName: productData?.photoGalleryName,
    photoGalleryDescription: productData?.photoGalleryDescription,
    photoType: productData?.photoType,
    PhotoGalleryImage: productData?.PhotoGalleryImage || [],
  });

  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.photoGalleryName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Handle state changes such as progress, pause, and resume
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setUploadPhotoGallery(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          reject(error);
          setLoading(false);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              PhotoGalleryImage: [...prev.PhotoGalleryImage, downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  
  const handleDeleteLogo = (index) => {
    //console.log("clicl");
    const newLogos = [...data.PhotoGalleryImage];
    newLogos.splice(index, 1);
    setData((pre) => {
      return {
        ...pre,
        PhotoGalleryImage: [...newLogos],
      };
    });
  };


  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    //console.log(projectKey);
    const docRef = doc(db, "photoGallery", projectKey);
    await updateDoc(docRef, data);
    setLoading(false);
    toast.success("Image Updated");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Edit Images</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="photoGalleryName">Photo Name :</label>
          <input
            type="text"
            id="photoGalleryName"
            placeholder="Enter Photo name"
            value={data.photoGalleryName}
            name="photoGalleryName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="photoGalleryDescription">Percentage:</label>
          <input
            type="text"
            id="photoGalleryDescription"
            placeholder="Enter Description"
            value={data.photoGalleryDescription}
            name="photoGalleryDescription"
            onChange={handleOnChange}
            min={0}
            max={100}
            className="input"
            required
          />
          <label htmlFor="photoType">Select Photo Type:</label> 
          <select
            required
            value={data.photoType}
            name="photoType"
            onChange={handleOnChange}
            className="input"
          >

            <option value="desktop" key="desktop">Desktop</option>
            <option value="mobile" key="mobile">Mobile</option>
          </select>
          <label htmlFor="PhotoGalleryImage" className="label">
          Images :
          </label>
          <label htmlFor="PhotoGalleryImage">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Images</p>
                <input
                  type="file"
                  id="PhotoGalleryImage"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadPhotoGallery > 0 && uploadPhotoGallery < 100 && (
            <label
              style={{ color: "blue", textAlign: "center" }}
            >{`Upload is ${uploadPhotoGallery}% done`}</label>
          )}

          <div>
            {data.PhotoGalleryImage.length > 0 ? (
              <div className="image-preview">
                {data.PhotoGalleryImage.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Images</p>
            )}
          </div>

         
          <button className="submit-button">Update Images</button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};
    
export default AdminEditPhotoGallery;
